import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/progressphases`;
const token = localStorage.getItem("token");

/// GET
// Récupérer toutes les phases de progression
export const getAllProgressPhases = async () => {
  try {
    const response = await axios.get(`${apiUrl}/AllProgressPhases`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data) {
      return response.data;
    } else {
      console.warn("Aucune phase de progression trouvée.");
      return [];
    }
  } catch (error) {
    console.error(
      "Erreur lors du chargement des phases de progression :",
      error
    );
    return [];
  }
};

// Récupérer une phase par son ID
export const getProgressPhaseById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/ProgressPhaseById/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération de la phase :", error);
    return null;
  }
};

/// POST
// Ajouter une nouvelle phase
export const addProgressPhase = async (phaseData) => {
  try {
    const response = await axios.post(`${apiUrl}/addProgressPhase`, phaseData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de la phase :", error);
    return null;
  }
};

/// PATCH
// Modifier une phase existante
export const updateProgressPhase = async (id, phaseData) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/updateProgressPhase/${id}`,
      phaseData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de la phase :", error);
    return null;
  }
};

/// DELETE
// Supprimer une phase
export const deleteProgressPhase = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteProgressPhase/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de la phase :", error);
    return null;
  }
};
